import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../AppContextProvider";
import close from "../assets/media/icons/cross-thin.svg";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
} from "mdb-react-ui-kit";

export default function InfoModalRight(props) {
  const { t } = useTranslation();
  const context = useContext(AppContext);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="central-info-modal">
        <MDBModalDialog scrollable centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <span className="title-text">{t('modals.walletLogin.title')}</span>
              </MDBModalTitle>
              <MDBBtn className="button subtle large" type="button" onClick={props.hideModal}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="var(--text-accent-maxi)"
                  />
                </svg>
              </MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="content">
                <h3 className="text-wrapper">{t('modals.walletLogin.subtitle')}</h3>
                <p className="div p18">
                  {t('modals.walletLogin.intro')}
                </p>
                <h4 className="p">{t('modals.walletLogin.authenticationAndSecurity')}</h4>
                <ul className="decentralization-at">
                  <li>
                    <span className="span">{t('modals.walletLogin.decentralizedAuthentication')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.walletLogin.decentralizedAuthenticationDesc')}
                      <br />
                    </span>
                  </li>
                  <li>
                    <span className="span">{t('modals.walletLogin.identityVerification')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.walletLogin.identityVerificationDesc')}
                      <br />
                    </span>
                  </li>
                </ul>
                <h4 className="p">{t('modals.walletLogin.interactionWithDApps')}</h4>
                <ul className="decentralization-at">
                  <li>
                    <span className="span">{t('modals.walletLogin.accessAndTransactions')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.walletLogin.accessAndTransactionsDesc')}
                      <br />
                    </span>
                  </li>
                </ul>
                <h4 className="p">{t('modals.walletLogin.userControlAndPrivacy')}</h4>
                <ul className="decentralization-at">
                  <li>
                    <span className="span">{t('modals.walletLogin.ownership')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.walletLogin.ownershipDesc')}
                      <br />
                    </span>
                  </li>
                  <li>
                    <span className="span">{t('modals.walletLogin.privacy')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.walletLogin.privacyDesc')}
                      <br />
                    </span>
                  </li>
                </ul>
                <div>
                  <span className="under-text p18">
                    {t('modals.walletLogin.summary')}
                  </span>
                </div>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
